var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFriendsFamilyDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 214.3 200",
    style: {
      enableBackground: "new 0 0 214.3 200"
    },
    xmlSpace: "preserve",
    width: "3rem",
    height: "3rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0 { fill: #333d45; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.6,114.3h-15C10.5,114.3,0,108.9,0,96.5c0-9-0.3-39.4,13.8-39.4c2.3,0,14,9.5,29,9.5c5.1,0,10-0.9,14.8-2.6 c-0.3,2.5-0.6,4.9-0.6,7.4c0,10.2,3.2,20.2,9,28.6C54.6,100.3,44.1,105.4,36.6,114.3z M42.9,57.1c-15.7,0-28.6-12.8-28.6-28.6 S27.1,0,42.9,0s28.6,12.8,28.6,28.6S58.6,57.1,42.9,57.1z M155.9,200H58.4c-17.9,0-29.8-10.8-29.8-28.9c0-25.2,5.9-64,38.6-64 c3.8,0,17.6,15.5,40,15.5s36.2-15.5,40-15.5c32.7,0,38.6,38.7,38.6,64C185.7,189.2,173.8,200,155.9,200z M107.1,114.3 c-23.7,0-42.9-19.2-42.9-42.9s19.2-42.9,42.9-42.9S150,47.8,150,71.4S130.8,114.3,107.1,114.3z M171.4,57.1 c-15.7,0-28.6-12.8-28.6-28.6S155.7,0,171.4,0S200,12.8,200,28.6S187.2,57.1,171.4,57.1z M192.6,114.3h-15c-7.5-8.9-18-14-29.6-14.3 c5.8-8.4,9-18.4,9-28.6c0-2.5-0.2-4.9-0.6-7.4c4.8,1.7,9.7,2.6,14.8,2.6c15.1,0,26.7-9.5,29-9.5c14.2,0,13.8,30.4,13.8,39.4 C214.3,108.9,203.8,114.3,192.6,114.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendsFamilyDiscount);
export default __webpack_public_path__ + "static/media/Friends_Family_Discount.837a4f84944f781cdc0afe0aa1b2a2e6.svg";
export { ForwardRef as ReactComponent };